import React, { forwardRef } from "react";
import { pickLang } from "../i18n/strings";

// Card 9:16 (Instagram Story format) — renderizzata off-screen per export PNG.
// Dimensioni: 1080 x 1920 px (usiamo scale in html2canvas).
const ShareCard = forwardRef(function ShareCard({ result, lang = "it" }, ref) {
  const t = pickLang(lang);
  const [o1, o2] = result.oils;
  return (
    <div
      ref={ref}
      data-testid="share-card"
      style={{
        width: 1080,
        height: 1920,
        background:
          "radial-gradient(ellipse at 20% 10%, #F7F3E9 0%, transparent 55%), radial-gradient(ellipse at 90% 90%, #EDE6EA 0%, transparent 55%), #FAF8F5",
        color: "#2B2825",
        padding: "120px 100px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: 28, letterSpacing: "0.28em", textTransform: "uppercase", color: "#968F87" }}>
          Aroma Compass
        </div>
        <div style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: 22, letterSpacing: "0.24em", color: "#C5A059" }}>
          · N ·
        </div>
      </div>

      {/* Bloccentrale */}
      <div style={{ display: "flex", flexDirection: "column", gap: 40 }}>
        <div style={{ fontFamily: '"Fraunces", serif', fontStyle: "italic", fontSize: 44, color: "#68625C", fontWeight: 300 }}>
          {t.cardLead}
        </div>

        <div
          style={{
            fontFamily: '"Fraunces", serif',
            fontWeight: 300,
            fontSize: result.name.length > 22 ? 120 : 148,
            lineHeight: 0.95,
            letterSpacing: "-0.02em",
          }}
        >
          {result.name}
        </div>

        <div style={{ height: 1, background: "rgba(43,40,37,0.2)", width: "60%" }} />

        <div style={{ fontFamily: '"Fraunces", serif', fontSize: 56, fontWeight: 400, color: "#2B2825" }}>
          {o1.name} <span style={{ color: "#C5A059" }}>+</span> {o2.name}
        </div>

        <div style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: 36, letterSpacing: "0.18em", textTransform: "uppercase", color: "#A28B97" }}>
          {result.keywords[0]} <span style={{ color: "#C5A059", margin: "0 18px" }}>×</span> {result.keywords[1]}
        </div>
      </div>

      {/* Intenzione */}
      <div>
        <div style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: 22, letterSpacing: "0.28em", textTransform: "uppercase", color: "#968F87", marginBottom: 24 }}>
          {t.cardIntentionLabel}
        </div>
        <div style={{ fontFamily: '"Fraunces", serif', fontStyle: "italic", fontSize: 52, lineHeight: 1.25, fontWeight: 300, color: "#2B2825" }}>
          «{result.intention}»
        </div>
      </div>

      {/* Footer */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div style={{ fontFamily: '"Fraunces", serif', fontStyle: "italic", fontSize: 30, color: "#68625C" }}>
          {t.cardAuthor}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 42, height: 42, borderRadius: 999, border: "1px solid #C5A059", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ width: 2, height: 22, background: "#C5A059" }} />
          </div>
          <div style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: 20, letterSpacing: "0.28em", color: "#968F87", textTransform: "uppercase" }}>
            aromacompass
          </div>
        </div>
      </div>
    </div>
  );
});

export default ShareCard;
